import React from "react"
import { withTheme } from "emotion-theming"
import { Box } from "@rebass/grid/emotion"
import { readableColor } from "polished"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import { Row } from "@components/grid"
import Panel from "@components/panel"
import { Pullquote } from "@components/type"

import GibsonCard from "./gibson-card"
import LinCard from "./lin-card"

const sectionTitle = "Volunteer Services"

const Volunteer = ({ theme }) => (
  <section>
    <Panel background={theme.colours.primary}>
      <h1>{sectionTitle}</h1>
      <Pullquote colour={readableColor(theme.colours.primary)}>
        To all of our volunteers, who give the very best of themselves so that
        we can be there for our community, we thank you!
      </Pullquote>
      <Row>
        <Box
          px={4}
          width={[1, 1, 1 / 2]}
          flex="1 1 auto"
          style={{ display: "flex" }}
        >
          <LinCard colour={theme.colours.primary} />
        </Box>
        <Box
          px={4}
          width={[1, 1, 1 / 2]}
          flex="1 1 auto"
          style={{ display: "flex" }}
        >
          <GibsonCard colour={theme.colours.primary} />
        </Box>
      </Row>
      <ViewButton to="/volunteer" colour={readableColor(theme.colours.primary)}>
        View
        <VisuallyHidden> {sectionTitle}</VisuallyHidden>
      </ViewButton>
    </Panel>
  </section>
)

export default withTheme(Volunteer)
